import { memo } from 'react';
import { TooltipTrigger, Button } from 'react-aria-components';
import { Tooltip } from 'components/tooltip/Tooltip';
import type { ButtonProps } from 'react-aria-components';
import { renderLitresToHL, roundNumberOneDecimal } from 'components/global/utils';
import { StatisticCardData } from 'components/statistic-card/StatisticCardData';



interface StatisticCardProps extends ButtonProps {
	data: StatisticCardData,
}


const StatisticCard = (props: StatisticCardProps) => {
	const { data, ...otherProps } = props;
	const { label, value, maxValue, volume, percent, state, tooltip } = data;


	const getStateClass = (state: 'danger' | 'warning' | 'success' | null | undefined) => {
		if (state === 'danger') return ' state-danger';
		if (state === 'warning') return ' state-warning';
		if (state === 'success') return ' state-success';
		return '';
	};

	return (
		<TooltipTrigger isDisabled={!Boolean(tooltip)}>
			<Button {...otherProps} className={`react-aria-Button component-statistic-card${getStateClass(state)}`}>
				
				<p className='card-name'>{label ? label : ''}</p>
				
				<p className='card-value'>
					{value !== undefined && value !== null ? value : '-'}
					{maxValue !== undefined && maxValue !== null ? <span className='card-value-max'> /{maxValue}</span> : ''}
				</p>
				
				<p className='card-volume'>{volume !== undefined && volume !== null && value ? `${renderLitresToHL(volume, 2)} hl` : ''}</p>
				
				<p className='card-percent'>{percent !== undefined && percent !== null && value ? `${roundNumberOneDecimal(percent)}%` : ''}</p>

				<div className='card-graph'></div>

			</Button>
			
			<Tooltip className='statistic-card-tooltip'>{tooltip}</Tooltip>
		</TooltipTrigger>
	);
}

export default memo(StatisticCard);